export default "__VITE_ASSET__uxEnQxEx__"